import posthog from 'posthog-js';

const POSTHOG_API_KEY = 'phc_vcxDvuCv787iKKPIN7r7dRUv1P11eACO9L39yHJWHWI';
const POSTHOG_HOST = 'https://eu.i.posthog.com';

const IS_DEV = process.env.REACT_APP_ENVIRONMENT !== 'production';

if (typeof window !== 'undefined' && !IS_DEV) {
  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
    loaded: posthog => {
      if (process.env.NODE_ENV === 'development') posthog.debug();
    },
  });
}

export const localAnalytics = () => ({
  logEvent: (eventName: string, properties?: Record<string, any>) => {
    if (IS_DEV) {
      console.log(`[Analytics Dev] ${eventName}`, properties);
      return;
    }

    if (typeof window !== 'undefined' && posthog) {
      if (properties && !properties.userId) {
        properties.userId = 'unauthenticated';
      }
      posthog.capture(`WebApp${eventName}`, properties);
    }
  },

  identify: (userId: string) => {
    if (IS_DEV) {
      console.log(`[Analytics Dev] Identify user: ${userId}`);
      return;
    }

    if (typeof window !== 'undefined' && posthog) {
      posthog.identify(userId);
    }
  },

  reset: () => {
    if (IS_DEV) {
      console.log('[Analytics Dev] Reset user');
      return;
    }

    if (typeof window !== 'undefined' && posthog) {
      posthog.reset();
    }
  },
});
